/* eslint-disable arrow-body-style */

/**
 * 视频文件相关工具方法
 */

const VIDEO_LOAD_ERR_MSG = 'video 后台加载失败';

/**
 * 格式化时间，返回常规视频时长的格式
 * @param duration 时长（单位秒）
 * @returns 格式化后的时长字符串（跟常规视频播放器显示的视频时长格式一致）
 */
export const formatVideoDuration = (duration: number | string): string => {
  const durationNum = Number.parseInt(duration as string, 10);
  if (Number.isNaN(durationNum)) return '00:00';
  let durationStr = '';
  let hours: number | string = Math.floor(durationNum / 3600);
  let minutes: number | string = Math.floor((durationNum % 3600) / 60);
  let seconds: number | string = Math.floor((durationNum % 3600) % 60);

  if (hours > 0) {
    hours = hours < 10 ? `0${hours}` : hours;
    durationStr += `${hours}:`;
  }
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${durationStr}${minutes}:${seconds}`;
};

/**
 * 加载指定url的视频资源，返回video对象
 * @param url 视频url
 * @returns video对象
 */
export const loadVideoByUrl = async (url: string): Promise<HTMLVideoElement> => {
  return new Promise((resolve) => {
    const video = document.createElement('video');
    // 当前帧的数据是可用的
    video.onloadeddata = () => {
      resolve(video);
    };
    // 加载失败
    video.onerror = (exception: any) => {
      console.error(exception?.message || VIDEO_LOAD_ERR_MSG);
      resolve(video);
    };
    // 设置 auto 预加载数据， 否则会出现截图为黑色图片的情况
    video.setAttribute('preload', 'auto');
    video.crossOrigin = 'anonymous';
    video.src = url;
  });
};

/**
 * 加载指定File的视频资源，返回video对象
 * @param file 视频资源文件对象
 * @returns video对象
 */
export const loadVideoByFile = async (file: File): Promise<HTMLVideoElement> => {
  let url = '';
  let video;
  try {
    url = URL.createObjectURL(file);
    video = await loadVideoByUrl(url);
  } catch (exception: any) {
    console.error(exception?.message || VIDEO_LOAD_ERR_MSG);
    video = document.createElement('video');
  }

  if (url) {
    URL.revokeObjectURL(url);
  }

  return video;
};

/**
 * 获取指定Video对象的缩略图
 * @param video Video对象
 * @param options 配置项
 * @param options.mimeType 图片的mimeType类型
 * @param options.quality 转图片的清晰度
 * @returns Video的缩略图
 */
export const getThumbOfVideo = (
  video: HTMLVideoElement,
  options?: {
    mimeType?: string;
    quality?: number;
  },
): string => {
  const { mimeType = 'image/png', quality = 1 } = options || {};
  const canvas = document.createElement('canvas');
  const { videoWidth = 0, videoHeight = 0 } = video || {};
  canvas.width = videoWidth;
  canvas.height = videoHeight;
  canvas.getContext('2d')?.drawImage(video, 0, 0, videoWidth, videoHeight);
  // 导出为dataURL
  return canvas.toDataURL(mimeType, quality);
};
